import { Box, styled } from "@mui/system";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export const FormContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  justifyContent: "center",
  marginBottom: "20px",
  width:'400px'
});

export const ButtonsContainer = styled(Box)({
  // margin: "0 25px",
  "& .MuiButtonBase-root": {
    marginRight: "18px",
    height: "26px",
    fontSize: "12px",
  },
});

export const ResetPassworButton = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: "pointer",
}));
export const CopyIcon = styled(ContentCopyIcon)({
  display: "flex",
  alignSelf: "center",
  cursor: "pointer",
  height: "20px",
});